import React from "react";

/**
 * The Material icons the Felix app's voucher screen uses, as inline SVG.
 *
 * `voucher_page.dart` draws these through Flutter's bundled Material set
 * (`Icons.place_outlined`, `Icons.local_offer_outlined`, and so on). Reproducing
 * them here keeps the preview matching the app without pulling an icon font
 * into the dashboard for five glyphs.
 */
const svg = (path, { filled = false } = {}) =>
  function Icon() {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d={path}
          fill={filled ? "currentColor" : "none"}
          stroke={filled ? "none" : "currentColor"}
          strokeWidth={filled ? 0 : 1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

/** Icons.arrow_back */
export const ArrowBack = svg("M19 12H5M12 19l-7-7 7-7");

/** Icons.place_outlined */
export const Place = svg(
  "M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z M12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
);

/** Icons.local_offer_outlined */
export const LocalOffer = svg(
  "M20.6 12.4 12 3.8H4v8l8.6 8.6a1.7 1.7 0 0 0 2.4 0l5.6-5.6a1.7 1.7 0 0 0 0-2.4Z M7.5 8.5h.01"
);

/** Icons.storefront_outlined */
export const Storefront = svg(
  "M4 9v11h16V9 M3 9l1.5-5h15L21 9a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0Z"
);

/** Icons.event_outlined */
export const Event = svg(
  "M4 6h16v14H4z M4 10h16 M8 3v4 M16 3v4"
);

/** Icons.event_busy_outlined */
export const EventBusy = svg(
  "M4 6h16v14H4z M4 10h16 M8 3v4 M16 3v4 M10 13.5l4 4 M14 13.5l-4 4"
);

/** Icons.check_circle (filled) */
export const CheckCircleFilled = svg(
  "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1.2 14.4-4-4 1.4-1.4 2.6 2.6 5.6-5.6 1.4 1.4-7 7Z",
  { filled: true }
);

/** Icons.check_circle_outline */
export const CheckCircle = svg(
  "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z M8.5 12l2.5 2.5 4.5-4.5"
);

/** Icons.star_border */
export const Star = svg(
  "m12 4 2.4 5 5.6.7-4 3.9 1 5.4-5-2.7-5 2.7 1-5.4-4-3.9 5.6-.7Z"
);
